/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */

import React from 'react'

import { FiAlertTriangle } from 'react-icons/fi'

/**
 * Coordinates only ever come from picking a location — the address is copied
 * from that match. Typing over the address afterwards leaves the two describing
 * different places, silently, since nothing re-geocodes on save.
 *
 * Advisory: the edited address is often the more useful one to a human ("Dock 4,
 * …"), so this warns rather than blocks.
 */
export const AddressCoordinateWarning: React.FC<{ show: boolean; id?: string }> = ({ show, id }) =>
  show ? (
    <span
      className="label-text-alt mt-1 flex items-start gap-1 text-warning"
      data-testid={id ?? 'address-coordinate-warning'}
    >
      <FiAlertTriangle className="mt-0.5 h-3 w-3 shrink-0" />
      <span>Address changed — may not match the coordinates. Use the Location field for exact matching.</span>
    </span>
  ) : null
